import { Stack } from '@mui/material';
import ProductMasterTable from './Table/ProductMasterTable';
import { useState } from 'react';
import { useBoundStore } from 'useStore';
import useProductMasterMutation from './Queries/ProductMasterMutation';

export default function ProductMasterTab() {
	const mutation = useProductMasterMutation();
	const [loading, setLoading] = useState(false);
	const setAlertState = useBoundStore((state) => state.setAlertState);

	const setLocalChannels = useBoundStore((state) => state.setLocalChannels);

	const handleSentData = async (items) => {
		setLoading(true);
		const transformedData = items;
		mutation.mutate(transformedData, {
			onSuccess: (data) => {
				setLoading(false);
				setAlertState({
					open: true,
					message: 'Se guardaron los datos correctamente',
					title: 'Success',
					errors: [],
					severity: 'success',
				});
				console.log('Éxito al enviar:', data);
				setLocalChannels({});
			},
			onError: (error) => {
				setLoading(false);
				setAlertState({
					open: true,
					message:
						'Por favor inténtalo nuevamente en unos minutos ó recargue la página.',
					title: 'Error al guardar la solicitud.',
					errors: [],
					severity: 'error',
				});
				console.error('Error al enviar:', error);
			},
		});
		setLoading(false);
	};
	return (
		<Stack spacing="24px">
			<ProductMasterTable handleSentData={handleSentData} loading={loading} />
		</Stack>
	);
}
